import request from "@/util/request.js";
//顾客查询销售单列表
export const getSalesList = (params) =>
  request({
    url: "/wms/wx/officialAccount/salePage",
    method: "GET",
    params,
  });
//顾客查询销售单详情列表
export const getSaleDetail = (params) =>
  request({
    url: "/wms/wx/officialAccount/saleDetails",
    method: "GET",
    params,
  });

/**
 * 销售货品列表
 * @param {sn}
 */
export const getSaleProductList = (params) =>
  request({
    url: "/wms/wx/officialAccount/productSnPage",
    method: "GET",
    params,
  });
